module.exports = __webpack_public_path__ + "static/22-0629dc14fd3dc038f421b7ebbbbc127c.jpg";